import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { extendedServiceStopStatuses } from 'types/timetableServices';
import { formatTime } from 'utils/dates';

import { TimetableTime, TimetableDetailData, TimetableDetailDataBoardingOnly } from './StopsSummary.style';

const StopArrival = ({
  extendedArrivalStatus,
  extendedDepartureStatus,
  arrivalDateTime,
  commercialArrivalDateTime,
  departureDateTime,
  commercialDepartureDateTime,
  scheduledDepartureDateTime,
  scheduledArrivalDateTime
}) => {
  const commercialTime = commercialArrivalDateTime ? formatTime(commercialArrivalDateTime) : formatTime(commercialDepartureDateTime);
  const scheduledTime = scheduledArrivalDateTime ? formatTime(scheduledArrivalDateTime) : formatTime(scheduledDepartureDateTime);
  const time = arrivalDateTime ? formatTime(arrivalDateTime) : formatTime(departureDateTime);
  const status = extendedArrivalStatus ? extendedArrivalStatus : extendedDepartureStatus;

  const isBoardingOnly =
    extendedArrivalStatus === extendedServiceStopStatuses.CANCELLED && extendedDepartureStatus !== extendedServiceStopStatuses.CANCELLED;

  switch (status) {
    case extendedServiceStopStatuses.CANCELLED:
      return (
        <TimetableTime>
          <TimetableDetailData status={status}>{commercialTime || scheduledTime}</TimetableDetailData>
          {isBoardingOnly && (
            <TimetableDetailDataBoardingOnly status={status}>
              <FormattedMessage id="journeySegment.timetableArrivalCancelled" />
            </TimetableDetailDataBoardingOnly>
          )}
        </TimetableTime>
      );
    case extendedServiceStopStatuses.ARRIVED_LATE:
    case extendedServiceStopStatuses.DEPARTED_LATE:
    case extendedServiceStopStatuses.ARRIVED_EXPECTED_LATE:
    case extendedServiceStopStatuses.DEPARTED_EXPECTED_LATE:
    case extendedServiceStopStatuses.EXPECTED:
      return (
        <TimetableTime>
          <TimetableDetailData status={status}>{commercialTime || scheduledTime}</TimetableDetailData>
          <TimetableDetailData>{time}</TimetableDetailData>
        </TimetableTime>
      );
    default:
      return (
        <TimetableTime>
          <TimetableDetailData status={status}>{commercialTime || scheduledTime}</TimetableDetailData>
        </TimetableTime>
      );
  }
};

StopArrival.propTypes = {
  extendedArrivalStatus: PropTypes.oneOf(Object.keys(extendedServiceStopStatuses)),
  extendedDepartureStatus: PropTypes.oneOf(Object.keys(extendedServiceStopStatuses)),
  arrivalDateTime: PropTypes.instanceOf(Date),
  commercialArrivalDateTime: PropTypes.instanceOf(Date),
  departureDateTime: PropTypes.instanceOf(Date),
  commercialDepartureDateTime: PropTypes.instanceOf(Date),
  scheduledDepartureDateTime: PropTypes.instanceOf(Date),
  scheduledArrivalDateTime: PropTypes.instanceOf(Date)
};

export default injectIntl(StopArrival);
